export enum TransactionStatus {
    ctsCleared = "CLEARED",
    ctsDeclined = "DECLINED",
    ctsReversed = "REVERSED",
    ctsPending = "PENDING",
    ctsApproved = "APPROVED",
    ctsRefund = "REFUND",
    ctsDispute = "DISPUTE",
    ctsExpired = "EXPIRED",
    ctsProcessing = "PROCESSING"
}
 export declare type TransactionType = keyof typeof TransactionStatus;